/* eslint-disable @next/next/no-img-element */
import React, { useState } from 'react';
import ContainerHome24 from '../../atoms/ContainerHome24';
import WhiteButton from '../../atoms/WhiteButton/WhiteButton';
import Styles from './Home24HeroCPAuto.css';
import RedButton from '@/components/atoms/RedButton';

function Home24HeroCPAuto() {
  const [width, setWidth] = useState(typeof window === 'undefined' ? 0 : window.window.innerWidth);

  if (typeof window === 'undefined') {
    console.log('');
  } else {
    window.addEventListener('resize', function () {
      setWidth(window.window.innerWidth);
    });
  }
  return (
    <>
      <section id="hero-santander-financiamentos">
        <div className="bg-hero">
          {typeof window === 'undefined' ? (
            <></>
          ) : (
            <>
              {width <= 599 && (
                <picture>
                  <source type="image/png" srcSet="assets/home24/hero-cp-auto/banner-312.png" />
                  <img
                    src="assets/home24/hero-cp-auto/banner-312.png"
                    alt="Banner com fundo vermelho exibindo homem apoiado em um carro vermelho utilizado como garantia em um empréstimo com garantia de veículos no Santander com taxas a partir de 1,39%."
                    className=""
                  />
                </picture>
              )}
              {/* {width > 450 && width <= 599 && (
                <picture>
                  <source type="image/png" srcSet="assets/home24/hero-cp-auto/banner-450.png" />
                  <img
                    src="assets/home24/hero-cp-auto/banner-450.png"
                    alt="Banner com fundo vermelho exibindo homem apoiado em um carro vermelho utilizado como garantia em um empréstimo com garantia de veículos no Santander com taxas a partir de 1,39%."
                    className=""
                  />
                </picture>
              )} */}
              {width > 599 && width <= 799 && (
                <picture>
                  <source type="image/png" srcSet="assets/home24/hero-cp-auto/banner-600.png" />
                  <img
                    src="assets/home24/hero-cp-auto/banner-600.png"
                    alt="Banner com fundo vermelho exibindo homem apoiado em um carro vermelho utilizado como garantia em um empréstimo com garantia de veículos no Santander com taxas a partir de 1,39%."
                    className=""
                  />
                </picture>
              )}
              {width > 799 && width <= 1280 && (
                <picture>
                  <source type="image/png" srcSet="assets/home24/hero-cp-auto/banner-800.png" />
                  <img
                    src="assets/home24/hero-cp-auto/banner-800.png"
                    alt="Banner com fundo vermelho exibindo homem apoiado em um carro vermelho utilizado como garantia em um empréstimo com garantia de veículos no Santander com taxas a partir de 1,39%."
                    className=""
                  />
                </picture>
              )}
              {width > 1280 && width <= 1359 && (
                <picture>
                  <source type="image/png" srcSet="assets/home24/hero-cp-auto/banner-1280.png" />
                  <img
                    src="assets/home24/hero-cp-auto/banner-1280.png"
                    alt="Banner com fundo vermelho exibindo homem apoiado em um carro vermelho utilizado como garantia em um empréstimo com garantia de veículos no Santander com taxas a partir de 1,39%."
                    className=""
                  />
                </picture>
              )}
              {width > 1359 && width <= 1920 && (
                <picture>
                  <source type="image/png" srcSet="assets/home24/hero-cp-auto/banner-1920.png" />
                  <img
                    src="assets/home24/hero-cp-auto/banner-1920.png"
                    alt="Banner com fundo vermelho exibindo homem apoiado em um carro vermelho utilizado como garantia em um empréstimo com garantia de veículos no Santander com taxas a partir de 1,39%."
                    className=""
                  />
                </picture>
              )}
              {width > 1920 && (
                <picture>
                  <source type="image/png" srcSet="assets/home24/hero-cp-auto/banner-2650.png" />
                  <img
                    src="assets/home24/hero-cp-auto/banner-2650.png"
                    alt="Banner com fundo vermelho exibindo homem apoiado em um carro vermelho utilizado como garantia em um empréstimo com garantia de veículos no Santander com taxas a partir de 1,39%."
                    className=""
                  />
                </picture>
              )}
            </>
          )}
        </div>
        <ContainerHome24>
          <div className="hero-contain">
            <div className="hero-buttons">
              <WhiteButton
                href="emprestimo-garantia-carro.html?int_source=portalSF&int_medium=home-hero-banner&int_campaign=simular"
                id="hero-button-simular-financiamento"
                wide
              >
                Simular
              </WhiteButton>
              <RedButton href="#santander-carousel" id="hero-button-outros-produtos">
                Produtos
              </RedButton>
            </div>
          </div>
        </ContainerHome24>
        <style jsx>{Styles}</style>
      </section>
    </>
  );
}

export default Home24HeroCPAuto;
